export enum Constants {
    MENUBAR_SELECTMAILS = 'MENUBAR_SELECTMAILS',
    MENUBAR_SET_TOUCH_SELECT_ACTIVE = 'MENUBAR_SET_TOUCH_SELECT_ACTIVE',
    MENUBAR_SET_SELECTED_ITEM_FOLDER_ACTION = 'MENUBAR_SET_SELECTED_ITEM_FOLDER_ACTION',
    MENUBAR_SET_SELECTED_BUTTON_ACTION = 'MENUBAR_SET_SELECTED_BUTTON_ACTION',
    MENUBAR_SET_ENABLE_PRINT_BUTTON = 'MENUBAR_SET_ENABLE_PRINT_BUTTON',
    MENUBAR_SET_ENABLE_DISABLE_READUNREAD_BUTTON = 'MENUBAR_SET_ENABLE_DISABLE_READUNREAD_BUTTON',
    MENUBAR_SET_ENABLE_DISABLE_ADDREMOVE_FLAG_BUTTON = 'MENUBAR_SET_ENABLE_DISABLE_ADDREMOVE_FLAG_BUTTON',
    MENUBAR_SET_ENABLE_DISABLE_MOVE_TO_FOLDER_MENU_ITEM = 'MENUBAR_SET_ENABLE_DISABLE_MOVE_TO_FOLDER_MENU_ITEM',
}
